export default "https://cdn-static.gokick.com/assets/b944ecdade3ab4b24738bd1fcec1eea00d00fb75/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";